<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="12">
          <div class="page-title">平台用戶列表</div>
        </el-col>
        <el-col :span="6" :offset="6" style="text-align: right;">
          <el-button type="info" @click.native="onAdd">新增用戶帳號</el-button>
        </el-col>
      </el-row>
      <div class="page-content">
        <div class="page-box">
          <div class="page-content-row">
            <div>
              <div class="search-text">電郵地址</div>
              <el-input
                v-model="listQuery.emailLike"
                placeholder="搜尋電郵地址"
              ></el-input>
            </div>
            <div>
              <div class="search-text">用戶姓名</div>
              <el-input
                v-model="listQuery.nameLike"
                placeholder="搜尋用戶姓名"
              ></el-input>
            </div>
            <div>
              <div class="search-text">電話</div>
              <el-input
                v-model="listQuery.phoneLike"
                placeholder="搜尋聯繫方式"
              ></el-input>
            </div>
            <div>
              <el-button type="info" class="button-el-el" @click.native="onSearch"
                >搜尋</el-button
              >
            </div>
            <div>
              <el-button
                type="success"
                class="button-el-el"
                @click.native="onReset"
                >清除篩選</el-button
              >
            </div>
            <div style="text-align: right;">
              <el-button type="info" @click="onDownload" class="button-el-el">下載</el-button>
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
        >
          <el-table-column
            prop="email"
            label="電郵地址"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="用户姓名"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="帳號狀態"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{ row }">
              <span :class="{'studentCode': row.status==1,'isStudentCode':row.status==0}">{{ row.status | studentCodeStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="電話"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="創建時間"
            align="center"
            sortable="custom"
          >
          <template slot-scope="scope">
            <span>{{ scope.row.createdAt | formatDateTime }}</span>
          </template>
          </el-table-column>

          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="medium"
                @click="onEditorButton(scope.row.id)"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(scope.row.id)"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery._page"
      :limit.sync="listQuery._limit"
      @pagination="getUsers"
    />
  </div>
</template>

<script>
import {getUserReport} from "@/api/report";
import {getUsers} from "@/api/users";
import Pagination from "@/components/Pagination";
import {downloadFile} from "@/utils/is-rules";
export default {
  components: { Pagination },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
  },
  data() {
    return {
      total: 0,
      userId: null,
      listQuery: {
        type: 0,
        userNoLike: null,
        nameLike: null,
        emailLike: null,
        phoneLike: null,
        gender: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      avatars: [],
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    onDownload(){
      this.getUserReport()
    },
    getUserReport() {
      let form = {
          nameLike: this.listQuery.nameLike || null, 
          emailLike: this.listQuery.emailLike || null, 
          phoneLike: this.listQuery.phoneLike || null,
      }
      getUserReport(form).then((res)=>{
          downloadFile(res.data,'userReport.xlsx')
      })
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getUsers();
    },
    onSearch() {
      this.getUsers();
    },
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if(key === '_page'){
          this.listQuery[key] = 1;
        }
        if(key === '_limit'){
          this.listQuery[key] = 50;
        }
      })
      this.getUsers();
    },
    onEditorButton(id) {
      let path = `/user/${id}/edit`
      this.resolveRouter(path)
    },
    onAdd() {
      let path = "/user/add"
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/user/${id}`
      this.resolveRouter(path)
    },
    getUsers() {
      let listQuery = {
        type: 1,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        emailLike: this.listQuery.emailLike,
        phoneLike: this.listQuery.phoneLike,
        gender: this.listQuery.gender,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      getUsers(listQuery).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
  .demo-ruleForm-div {
    margin-top: 40px;
  }
  ::v-deep {
    .cell {
      color: black;
    }
  }
}
.form-avatar {
  position: relative;
  width: 90px;
  height: 90px;
}

.page-content {
  background-color: #fff;
}
.page-box{
  width: 100%;
  overflow-x: auto;
}
.page-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(6, 170px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div:nth-last-child(1){
  width: 110px;
  grid-column-start: 10;
}
.page-content-row>div:nth-last-child(2){
  width: 118px !important;
}
.page-content-row>div:nth-last-child(3){
  width: 100px !important;
}
.button-el-el {
  margin-top: 30px;
}
.studentCode{
  color: #027915;
}
.isStudentCode{
  color: #9C0000;
}
//媒体查询
@media screen and (max-width: 1559px) {
  .page-content-row>div:nth-last-child(1){
    width: 110px;
    grid-column-start: 6;
  }
}
</style>